import { schema } from 'normalizr';
import { deviationSchema } from './deviation';
import { userSchema } from './user';
export var collectionFolderSchema = new schema.Entity('collectionFolder', {
    thumb: deviationSchema,
    owner: userSchema,
}, {
    idAttribute: 'folderId',
});
export var collectionListSchema = [collectionFolderSchema];
collectionFolderSchema.define({ subfolders: collectionListSchema });
export var galleryFolderSchema = new schema.Entity('galleryFolder', {
    thumb: deviationSchema,
    owner: userSchema,
}, {
    idAttribute: 'folderId',
});
export var galleryListSchema = [galleryFolderSchema];
galleryFolderSchema.define({ subfolders: galleryListSchema });
export var stashFolderSchema = new schema.Entity('stashFolder', {
    thumb: deviationSchema,
    owner: userSchema,
}, {
    idAttribute: 'folderId',
});
export var stashListSchema = [stashFolderSchema];
stashFolderSchema.define({ subfolders: stashListSchema });
//# sourceMappingURL=folder.js.map